import type { StorytellerState } from 'store/StorytellerReduxState';

export const getIsPersonalizedVersion = (state: StorytellerState) => {
  return state.personalizedStories.isPersonalizedVersion;
};
